<ion-card class="card-shadow-7" style="border-radius: 0.5em;height: 100% !important" *ngIf="waitlist_item.rank != -1">
    <ion-grid class="ion-no-padding" style="color: black; margin: 0.5em;">
        <ion-row>
            <ion-col style="padding: 0.4em;">
                <ion-label class="card-header-unique">WAITLIST</ion-label>
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col class="ion-no-padding">
                <h1 style="padding: 0.5em;margin: 0;" class="paragraph-bold">
                    <ion-icon style="vertical-align: middle; font-size: x-large;" name="location-outline"></ion-icon>
                    {{ waitlist_item.lot }}
                </h1>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="dataService.settings['permits']?.['show_waitlist_rank'] == true">
            <ion-col style="padding: 0.4em;">
                <h4>
                    {{('keys.data.permits.rank' | translate : {Default: "Rank"}) || "Rank"}}: <ion-text style="color: darkcyan; font-weight: bold;">#{{ waitlist_item.rank }}</ion-text>
                </h4>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-card>


